import { createFileRoute, Outlet } from '@tanstack/react-router';

import Nav from '@/features/auth/nav.component';
import { applyLocale } from '@/i18n';
import FaqLayout from '@/shared/components/layout/faq-layout.component';

export const Route = createFileRoute('/$locale/faq')({
  beforeLoad: ({ params }) => {
    applyLocale(params.locale);
  },
  component: () => (
    <FaqLayout nav={<Nav />}>
      <Outlet />
    </FaqLayout>
  ),
});
